/**
 * Adzuki
 * text_selection.js
 */
(function TextSelection($, Adzuki)
{
	"use strict";

	var TextSelection = {};

	$(document).ready(function documentReady()
	{
		var form_name = null;

		// we don't want to run this on every single page
		if ($('.texting-selection').length === 0) {
			return;
		}

		form_name = $('.texting-selection').data('form-name');

		// toggle checking and unchecking all recipients
		$('.texting-selection').on('click', '.text-recipient-checkall', function _checkUncheckAll() {
			if ($(this).prop('checked') === true) {
				$('.text-recipient-checkboxes').each(function _checkIt() {
					$(this).prop('checked', true);
				});

				_showSendTextButton(form_name);
			} else {
				$('.text-recipient-checkboxes').each(function _unCheckIt() {
					$(this).prop('checked', false);
				});

				_hideSendTextButton(form_name);
			}
		});

		// in the reservation invoice, do a check if there are no
		// recipients selected, if so, hide the "Send Text Now" button
		$('.texting-selection').on('change', '.text-recipient-checkboxes', function onCheckboxChange(e) {
			var checked_boxes = $('.text-recipient-checkboxes:checked').length;

			if (checked_boxes === 0) {
				_hideSendTextButton(form_name);
			} else {
				_showSendTextButton(form_name);
			}
		});
	});

	TextSelection.initRecipients = function initRecipients(form_name, text_type)
	{
		var form_id    = form_name.toLowerCase() + '-';
		var url        = '/Clients/searchClientsTexts/';
		var msg_length = 200;

		if (text_type) {
			url += text_type;
		} else {
			url += 'all';
		}

		if (
			$('#' + form_id + 'max_message_length').length > 0
			&& $('#' + form_id + 'max_message_length').val() !== ''
		) {
			msg_length = parseInt($('#' + form_id + 'max_message_length').val());
		}

		Adzuki.Typeahead(
			$('#' + form_id + 'recipient_search'),
			url,
			function select(client, $self, typeahead) {
				$self.val('');
				_addRecipient(form_name, form_id, client);
			},
			function template(client) {
				return client.full_name + ' - ' + Adzuki.String.formatPhoneNumber(client.mobile_phone);
			}
		);

		Adzuki.CharacterCount('#' + form_id + 'message', {
			max  : msg_length,
			label: '.text-message-count',
		});

		$('.text-recipient-checkall').click(function _checkUncheckAll() {
			var $checkboxes = $('.text-recipient-checkbox');

			if ($(this).prop('checked') === true) {
				$checkboxes.prop('checked', true);
			} else {
				$checkboxes.prop('checked', false);
			}
		});
	};

	function _addRecipient(form_name, form_id, client)
	{
		var $table      = $('.select-text-recipient');
		var index       = $table.find('tbody tr').length;
		var row_markup  = '';
		var check_attrs = {};

		$table.removeClass('hidden');

		check_attrs.type    = 'checkbox';
		check_attrs.checked = 'checked';
		check_attrs.id      = form_id + 'text_recipients-' + index;
		check_attrs.name    = 'form_component_data['+ form_name + '][text_recipients][' + index + ']';
		check_attrs.value   = client.id;
		check_attrs.class   = 'text-recipient-checkbox';

		row_markup += '<tr>';
		row_markup += '<td>' + $('<input />', check_attrs).prop('outerHTML') + '</td>';
		row_markup += '<td>' + client.full_name + '</td>';
		row_markup += '<td>' + Adzuki.String.formatPhoneNumber(client.mobile_phone) + '</td>';
		row_markup += '</tr>';

		$table.find('tbody').first().append(row_markup);
	}

	// hide the "Send Text Now" button in the appropriate form
	function _hideSendTextButton(form_name)
	{
		switch (form_name) {
			case 'CruiseSheetPrepare':
				$('.send-cruise-sheet-text').addClass('hidden');
			break;
			case 'ReservationGenerateInvoice':
				$('a.btn.send-email-btn').addClass('border-round-right');
				$('a.btn.send-text-btn').addClass('hidden').removeClass('border-round-right');
			break;
			case 'AllInclusivePropertySheetBuildPreview':
				$('.send-aip-sheet-text').addClass('hidden');
			break;
			case 'TourSheetsEdit':
				$('.send-tour-sheet-text').addClass('hidden');
			break;
			default:
				// make the linter happy
		}
	}

	// show the "Send Text Now" button in the appropriate form
	function _showSendTextButton(form_name)
	{
		switch (form_name) {
			case 'CruiseSheetPrepare':
				$('.send-cruise-sheet-text').removeClass('hidden');
			break;
			case 'ReservationGenerateInvoice':
				$('a.btn.send-email-btn').removeClass('border-round-right');
				$('a.btn.send-text-btn').removeClass('hidden').addClass('border-round-right');
			break;
			case 'AllInclusivePropertySheetBuildPreview':
				$('.send-aip-sheet-text').removeClass('hidden');
			break;
			case 'TourSheetsEdit':
				$('.send-tour-sheet-text').removeClass('hidden');
			break;
			default:
				// make the linter happy
		}
	}

	Adzuki.TextSelection = TextSelection;
}(jQuery, window.Adzuki || {}));
